import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider data-oid="gegdoh3">
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props} data-oid="u6:y7fa">
            <div className="grid gap-1" data-oid="q.04a:3">
              {title && <ToastTitle data-oid="3r-ipkt">{title}</ToastTitle>}
              {description && (
                <ToastDescription data-oid="_53--oe">
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose data-oid="q3pc2:8" />
          </Toast>
        );
      })}
      <ToastViewport data-oid="4zt1cfs" />
    </ToastProvider>
  );
}
